<template>
  <router-link :to="{ name: 'BlogDetail', params: { id: blog.id, slug: blog.slug }}" class="blog-card">
    <div class="blog-card__top">
      <img :src="blog.cover ? blog.cover : require('@/assets/img/blog-cover-default.jpg')" alt="yurtlarburada blog" class="blog-card__cover">
      <div class="blog-card__overlay">
        <v-button
          class="blog-card__button"
          title="Yazıyı Oku"
        />
      </div>
    </div>
    <div class="blog-card__cnt">
      <div class="blog-card__content">
        <div class="blog-card__date">{{ generateDate }}</div>
        <div class="blog-card__title">{{ blog.title }}</div>
      </div>
      <div class="blog-card-inf">
        <span class="blog-card-inf__icon">
          <svg-icon type="icon-user" />
        </span>
        <div class="blog-card-inf__title">{{ blog.author.first_name }} {{ blog.author.last_name }}</div>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'BlogCard',
  props: {
    blog: Object
  },
  computed: {
    generateDate () {
      let date = new Date(this.blog.created_at)
      return date.toLocaleDateString()
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/components/blog-card";
</style>
